import { gql } from "@apollo/client";

// Query to get the current user's information
export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    me {
      id
      email
      name
      approved
      joinDate
    }
  }
`;

// Query to get all events
export const GET_EVENTS = gql`
  query GetEvents($days: Int) {
    events(days: $days) {
      id
      title
      date
      time
      location
      privateLocation
      description
      generalpublic
    }
  }
`;

// Query to get all available chats
export const GET_CHATS = gql`
  query GetChats {
    chats {
      id
      name
      description
      imageUrl
      createdAt
      updatedAt
      memberCount
      messageCount
    }
  }
`;

// Query to get a specific chat with messages
export const GET_CHAT = gql`
  query GetChat($id: ID!) {
    chat(id: $id) {
      id
      name
      description
      imageUrl
      createdAt
      updatedAt
      memberCount
      messageCount
      members {
        id
        name
        nickname
        imageUrl
        autokicked
        muted
      }
      messages {
        id
        text
        name
        avatarUrl
        createdAt
        userId
        system
      }
    }
  }
`;
